export const aciFlightHotel = {
    iconName: 'flight-hotel',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 25' },
        path: [
            {
                attr: {
                    d: 'M3.53 16.917c-.253 0-.38-.126-.506-.253-.253-.252-.126-.631.126-.884l2.021-1.263c.379-.252.758-.631.884-1.136l1.263-2.905c0-.127.253-.253.38-.38l2.146-.504c.38-.127.632-.38.632-.632l.252-1.642c.127-.379-.126-.884-.505-1.01l-5.43-2.021c-.38-.126-.506-.505-.38-.884.127-.38.505-.505.758-.38l5.431 2.022c1.01.379 1.516 1.39 1.39 2.4l-.253 1.768c-.253.757-.758 1.389-1.642 1.642l-1.768.378-1.01 2.653a3.492 3.492 0 01-1.39 1.642L3.908 16.79c-.126.126-.253.126-.379.126zM16.033 9.844a.695.695 0 01-.632-.38l-.252-.883c-.38-1.137-.127-2.4.505-3.284l1.01-1.39c.253-.252.632-.378.884-.126.253.253.38.632.127.884l-1.01 1.39c-.506.631-.632 1.389-.38 2.147l.253.758c.126.378-.126.631-.379.757 0 .127 0 .127-.126.127z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M9.212 20.327s-.126 0 0 0C4.16 19.443.75 15.149 1.002 10.223c.254-4.926 4.169-8.841 9.22-9.22C15.15.75 19.57 4.16 20.328 9.086c0 .38-.126.632-.505.758-.38 0-.632-.126-.758-.505-.758-4.294-4.547-7.326-8.841-7.073a8.456 8.456 0 00-7.957 7.957c-.253 4.294 2.779 8.083 7.073 8.84.379 0 .631.38.505.759 0 .252-.379.505-.632.505z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M18.559 25c-.632 0-1.137-.379-1.263-1.01l-1.39-4.168-4.168-1.39c-.505-.126-.884-.631-1.01-1.263-.126-.631.379-1.136.884-1.389l12.63-5.178c.253-.127.505 0 .632.126.126.126.126.631.126.884l-5.178 12.63c-.253.379-.758.758-1.263.758zm4.673-12.504l-11.24 4.547-.127.126s0 .127.126.127l4.547 1.515c.126 0 .379.253.379.38l1.515 4.42s0 .126.127.126c0 0 .126 0 .126-.126l4.547-11.115z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M16.285 19.948c-.126 0-.378 0-.505-.126a.61.61 0 010-.884l2.905-2.779a.61.61 0 01.884 0 .61.61 0 010 .884l-2.778 2.779c-.127.126-.253.126-.506.126z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
